<template>
    <ValidationObserver ref="form">
        <h2 class="profile__title">Artist Information</h2>
        <div class="row mb-5">
            <div class="col-12">
                <div class="form-group mb-3">
                    <label for="" class="form-label">Represented to*</label>

                    <VueMultiSelect
                        :options="companies"
                        :selected_options="companyIds"
                        v-model="profileDetails.companies"
                    />

                </div>
            </div>
            <div class="col-md-6" v-show="showAgreement">
                <div class="form-group mb-3">
                    <label for="" class="form-label">Date of Signing*</label>
                    <input
                        type="date"
                        class="form-control pl-4"
                        v-model="profileDetails.agreement_date_sign"
                    >
                </div>
            </div>

            <div class="col-md-6" v-show="showAgreement">
                <div class="form-group mb-3">
                    <FileContainer
                        :file-info="agreement"
                        :user-id="artistId"
                        :field="`agreement`"
                        @upload-file="uploadFile"
                    >
                        <template v-slot:header>
                            <label for="" class="form-label">Exclusive Representation Agreement</label>
                        </template>
                    </FileContainer>
                </div>
            </div>

            <ValidationProvider
                class="col-12"
                name="Languages"
                v-slot="{ errors }"
                rules="required"
                mode="lazy"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Language*</label>
                    <FormError :error="errors[0]" name="Languages"></FormError>

                    <VueMultiSelect
                        :options="languages"
                        :selected_options="profileDetails.user_languages"
                        v-model="profileDetails.user_languages"
                    />
                </div>
            </ValidationProvider>

            <ValidationProvider
                v-if="showOther"
                name="lang other"
                v-slot="{ errors }"
                rules="required"
                class="col-12"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Language (other)</label>
                    <FormError :error="errors[0]" name="lang other"></FormError>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="profileDetails.other_user_languages"
                    >
                </div>
            </ValidationProvider>

            <ValidationProvider
                class="col-12"
                name="Biography"
                v-slot="{ errors }"
                rules="required"
            >
                <div class="form-group mb-3">
                    <FormError :error="errors[0]" name="Biography"></FormError>
                    <label for="" class="form-label">Biography*</label>
                    <textarea class="form-control large pl-4" v-model="profileDetails.bio"></textarea>
                </div>
            </ValidationProvider>

            <ValidationProvider
                name="Billing Information"
                v-slot="{ errors }"
                rules="required"
                class="col-12"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Billing information</label>
                    <FormError :error="errors[0]" name="Billing Information"></FormError>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="profileDetails.billing_information"
                    >
                </div>
            </ValidationProvider>
        </div>
    </ValidationObserver>
</template>

<script>
import {useArtistStore} from "../../stores/ArtistStore";
import FileContainer from "../Common/FileContainer.vue";
import FormError from "../Common/FormError.vue";
import { mapState, mapActions } from 'pinia'
import commonLists from "../../mixins/commonLists";

export default {
    name: "ArtistWorkInfo",
    components: {FormError, FileContainer},
    mixins: [commonLists],
    props: {
        agreement: {
            type: Object
        }
    },
    computed: {
        ...mapState(useArtistStore, {
            profileDetails: 'profileDetails',
            companies: 'companies',
            companyIds: 'companyIds',
            artistId: 'artistId',
            adminPermissions: 'adminPermissions',
        }),
        showAgreement() {
            if (this.adminPermissions) {
                return true
            } else return !!this.profileDetails.agreement;
        },
        showOther() {
            return this.profileDetails.user_languages && this.profileDetails.user_languages.map(id => +id).includes(33)
        }
    },
    methods: {
        uploadFile(file) {
            if (!file) {
                this.profileDetails.agreement = null
            } else {
                this.profileDetails.agreement = file.id
            }
        },
    },
    watch: {
        profileDetails: {
            handler(state) {
                this.dispatchState(state);
            },
            deep: true
        },
    }
}

</script>

<style scoped>

</style>
